/**
 * Shared form-field chrome — brand (Patient indigo) source of truth.
 *
 * The evaluation field primitives (EvaluationInput, EvaluationSelect,
 * InputDatePicker, EvaluationRadioGroup, EvaluationCommentSelect) are reused by
 * Patients, Application, Invoice and Documents, so their default look lives
 * here: change the brand once and every form follows.
 *
 * `accent-*` is what actually colors native radios/checkboxes — the app has no
 * @tailwindcss/forms plugin, so `text-indigo-600` alone leaves them browser blue.
 */
import { BRAND_THEME } from "./brandTheme";

export const FORM_FIELD = {
  label: "block text-sm font-medium text-slate-700 mb-2",
  /** Base chrome for input / select / textarea. */
  control: `block w-full px-4 py-2.5 text-sm border border-indigo-200 rounded-lg outline-none transition-colors ${BRAND_THEME.fieldFocus}`,
  enabled: "bg-white text-slate-800 placeholder:text-slate-400",
  disabled: "bg-indigo-50/40 text-slate-500 cursor-not-allowed",
  error: "border-red-400 focus:border-red-400 focus:ring-red-100",
  errorText: "text-red-500 text-xs mt-1",
  /** Static value shown where a field is display-only. */
  readonlyBox:
    "block w-full px-4 py-2.5 text-sm rounded-lg border border-indigo-200 bg-indigo-50/40 text-slate-700 font-medium",
  radio:
    "h-4 w-4 shrink-0 accent-indigo-600 text-indigo-600 border-slate-300 focus:ring-indigo-200",
  checkbox:
    "h-4 w-4 shrink-0 rounded accent-indigo-600 text-indigo-600 border-slate-300 focus:ring-indigo-200",
};
